// Lo que todavía se está analizando, TODO JUNTO en una sola sección
// (ADR-2026-10-02-onboarding-v2-tablero-con-cumbre): cuánto va y qué falta, sin explicar
// cada parte ni partirla en tarjetas. Cada parte sale de acá cuando está lista y aparece
// arriba como su propia sección. El texto va en neutro
// (ADR-2026-10-02-onboarding-v2-analisis-en-neutro).

export function AnalisisEnCurso(p: {
  /** Las partes que faltan, ya con su nombre, en orden. La primera es la que está en curso. */
  pendientes: Array<{ id: string; etiqueta: string }>;
  listos: number;
  total: number;
  manual: boolean;
}) {
  const porcentaje = Math.round((p.listos / Math.max(1, p.total)) * 100);
  return (
    <section className="om-en-curso" aria-live="polite" aria-busy="true">
      <div className="om-en-curso__dentro">
        <header className="flex items-center gap-3">
          <span className="om-en-curso__radar" aria-hidden="true">
            <span className="material-symbols-rounded">{p.manual ? 'auto_awesome' : 'travel_explore'}</span>
          </span>
          <div className="min-w-0 flex-1">
            <h2 className="text-[16px] font-extrabold leading-tight text-[#02062B]">
              {p.manual ? 'Armando el resto de tu marca' : 'Analizando el resto de tu marca'}
            </h2>
            <p className="mt-0.5 text-[13px] font-medium text-[#4B5275]">Cada parte aparece arriba apenas está lista.</p>
          </div>
          <span className="shrink-0 text-[13px] font-bold tabular-nums text-[#1644EB]">
            {p.listos} de {p.total}
          </span>
        </header>

        <div
          className="om-en-curso__barra"
          role="progressbar"
          aria-valuemin={0}
          aria-valuemax={p.total}
          aria-valuenow={p.listos}
          aria-label="Avance del análisis"
        >
          <span style={{ width: `${Math.max(6, porcentaje)}%` }} />
        </div>

        <ul className="flex flex-wrap gap-2" aria-label="Lo que falta">
          {p.pendientes.map((x, i) => (
            <li key={x.id} className={`om-en-curso__chip ${i === 0 ? 'is-ahora' : ''}`}>
              <span className="om-en-curso__punto" aria-hidden="true" />
              {x.etiqueta}
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
}

export default AnalisisEnCurso;
